(function () {
  if (window.pixPriceReady) return;
  window.pixPriceReady = true;

  var PICKERS = 'variant-radios-detail, variant-group-detail';

  function formatMoney(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      var format = window.themeGlobalVariables && themeGlobalVariables.settings && themeGlobalVariables.settings.money_format;
      return Shopify.formatMoney(cents, format);
    }
    return 'R$ ' + (cents / 100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  function update(block, price, compare) {
    var pct = parseFloat(block.dataset.pct) || 0;
    var pix = price - Math.round(price * pct / 100);

    var value = block.querySelector('[data-pix-value]');
    if (value) value.textContent = formatMoney(pix);
    var card = block.querySelector('[data-pix-card]');
    if (card) card.textContent = formatMoney(price);

    var compareEl = block.querySelector('[data-pix-compare]');
    if (compareEl) {
      if (compare && compare > price) {
        compareEl.textContent = formatMoney(compare);
        compareEl.hidden = false;
      } else {
        compareEl.textContent = '';
        compareEl.hidden = true;
      }
    }
  }

  document.addEventListener('change', function (event) {
    var picker = event.target.closest && event.target.closest(PICKERS);
    if (!picker) return;
    setTimeout(function () {
      var variant = picker.currentVariant;
      if (!variant || typeof variant.price !== 'number') return;
      var scope = picker.closest('.shopify-section') || document;
      scope.querySelectorAll('.pix-price--product[data-pix-price]').forEach(function (block) {
        update(block, variant.price, variant.compare_at_price);
      });
    }, 0);
  });
})();
